/**
 * DBにソートのカラムの指定で数値として記録されてしまっているので、明示的に値を振っている
 * 既存の項目の値を変更しないように注意が必要
 */
export enum DocumentListSortItemKinds {
  ContentDateTime = 0,
  PatientNo = 1,
  PatientName = 2,
  Department = 3,
  DocumentName = 4,
  CompanyName = 5,
  CreateStaffName = 6,
  OrderUserName = 7,
  AttendingUserName = 8,
  CreatedDateTime = 9,
  Published = 10,
  DescribedMethod = 11,
  Note = 12,
  Edition = 13,
  Id = 14,
  PublishedCount = 15,
  // 以下は特殊な値を定義する
  MultiCondition = 100, // 複数条件
  PresetMin = 101,  // プリセット用最小オフセット
  PresetMax = 120,  // プリセット用最大オフセット
}
